import Blank from './Blank';
import Homepage from './Homepage';
import FutureSightDetails from './FutureSightDetails';
import FutureSightLanding from './FutureSightLanding';
import FutureSightTag from './FutureSightTag';
import HeaderFlexContent from './HeaderFlexContent';
import HeroImage from './HeroImage';
import PressRoomLanding from './PressRoomLanding';
import CenterText from './CenterText';
import ErrorPage from './ErrorPage';
import VideoPlayerPage from './VideoPlayerPage';
import EventList from './EventList';
import Event from './Event';

export default {
  Blank,
  CenterText,
  ErrorPage,
  EventList,
  Event,
  FutureSightDetails,
  FutureSightLanding,
  FutureSightTag,
  HeaderFlexContent,
  HeroImage,
  Homepage,
  PressRoomLanding,
  VideoPlayerPage
};
